var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-514ab153.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-d8694455.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.997 16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.662 2.752.862 5.57.83 8.091Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124.171 21.34-.029 18.521.003 16Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M3.498 3.109 18 16 3.498 28.89C1.425 26.795.866 24.125.866 24.125c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .559-2.67 2.632-4.766Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M.069 13.333h31.87c.053.92.069 1.82.058 2.683.01.85-.009 1.738-.066 2.65H.061a38.244 38.244 0 0 1-.058-2.683c-.01-.85.009-1.737.066-2.65Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M2.552 4.233 16 16 2.552 27.767C1.248 25.95.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .382-1.825 1.686-3.642Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M.004 15h31.993c.004.344.004.683 0 1.016.004.323.004.651-.001.984H.003a39.42 39.42 0 0 1 0-1.017C0 15.661 0 15.333.004 15Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M1.754 5.54 13.667 16 1.754 26.46c-.67-1.293-.888-2.336-.888-2.336-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .218-1.042.888-2.335Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M5.073 20C6.398 20 9 19.005 9 15.8S6.225 12 5.395 12C4.565 12 2 12.583 2 15.205s2.515 2.865 3.01 2.865c.496 0 2.355-.437 2.144-2.404 0 .559-.644 1.736-1.995 1.736-1.35 0-2.193-.983-2.193-1.954 0-.972.818-2.27 2.243-2.27 1.425 0 2.465 1.238 2.465 2.488s-1.003 2.84-2.601 2.84V20Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M4.217 14.646c.784.291 1.404.704 1.864 1.238a.333.333 0 0 0 .505-.435c-.537-.623-1.25-1.099-2.136-1.428a.333.333 0 0 0-.233.625Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M6.45 14.646c-.785.291-1.404.704-1.864 1.238a.333.333 0 0 1-.505-.435c.537-.623 1.25-1.099 2.136-1.428a.333.333 0 0 1 .232.625Z"
    }
  )
), "SvgComponent"), SvgFlagVut = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagVut_default = SvgFlagVut;
export {
  FlagVut_default as default
};
